import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthenticationService } from '../../services/auth/authentication.service';

export const accountTypeGuard: CanActivateChildFn = (route, state) => {
  const authenticationService = inject(AuthenticationService);
  const router = inject(Router);
  
  const requiredAccountType = route.data['accountType'] as string;
  if (!requiredAccountType) {
    return true;
  }
  if (requiredAccountType === authenticationService.accountType) {
    return true;
  }
  return router.parseUrl('/login');
};
